import React from 'react';
import { Section } from './ui/Section';
import { Sparkles, Utensils, Clock } from 'lucide-react';
export function MechanismSection() {
  return <div className="bg-[#0D5C63] text-[#FFF8F0]" data-id="element-79">
      <Section data-id="element-80">
        <div className="text-center mb-12" data-id="element-81">
          <span className="uppercase tracking-widest text-[#C9A84C] font-bold text-sm mb-2 block" data-id="element-82">
            LA SOLUCIÓN ÚNICA
          </span>
          <h2 className="text-3xl md:text-5xl font-bold font-serif mb-6" data-id="element-83">
            El Método: Core Latino Posparto
          </h2>
          <p className="text-lg max-w-2xl mx-auto opacity-90" data-id="element-84">
            Hecho para ti: caos mamá latina USA. No gym. Resultados espejo día
            7.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-12" data-id="element-85">
          {/* Card 1 */}
          <div className="bg-[#0A4A50] p-8 rounded-2xl border border-[#C9A84C]/30 relative overflow-hidden group hover:border-[#C9A84C] transition-colors" data-id="element-86">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-[#C9A84C] opacity-10 rounded-full blur-xl" data-id="element-87"></div>
            <Sparkles className="w-10 h-10 text-[#C9A84C] mb-6" data-id="element-88" />
            <h3 className="text-xl font-bold mb-3 font-serif" data-id="element-89">
              5 Movimientos Sentados/En Cama
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed" data-id="element-90">
              12min post-amamantar. Activan transverso (faja natural) sin
              diástasis riesgo.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-[#0A4A50] p-8 rounded-2xl border border-[#C9A84C]/30 relative overflow-hidden group hover:border-[#C9A84C] transition-colors" data-id="element-91">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-[#C9A84C] opacity-10 rounded-full blur-xl" data-id="element-92"></div>
            <Utensils className="w-10 h-10 text-[#C9A84C] mb-6" data-id="element-93" />
            <h3 className="text-xl font-bold mb-3 font-serif" data-id="element-94">
              5 Swaps Latinos Invisibles
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed" data-id="element-95">
              Arroz → coliflor (familia no nota), frijoles → lentejas. Queman
              300cal/día.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-[#0A4A50] p-8 rounded-2xl border border-[#C9A84C]/30 relative overflow-hidden group hover:border-[#C9A84C] transition-colors" data-id="element-96">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-[#C9A84C] opacity-10 rounded-full blur-xl" data-id="element-97"></div>
            <Clock className="w-10 h-10 text-[#C9A84C] mb-6" data-id="element-98" />
            <h3 className="text-xl font-bold mb-3 font-serif" data-id="element-99">
              Timing Hormonal
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed" data-id="element-100">
              Ejercicio cuando cortisol bajo (post-leche). Respiración faja +
              vibración cierran separación.
            </p>
          </div>
        </div>
      </Section>
    </div>;
}